// requires "./custom-product-dropdown-selector-data.js";

class CustomDropDowns {
    static MAXCHARACTERS = 62;

    constructor(containerSelector = "#product-dropdown-container") {
        this.container = document.querySelector(containerSelector);
        if (!this.container) return;

        // Page Element Cache
        this.elements = {
            interactive: {
                year: document.querySelector("#dropdown-container-year"),
                medium: document.querySelector("#dropdown-container-medium"),
                entry: document.querySelector("#dropdown-container-entry"),
                company: document.querySelector("#dropdown-container-company"),
                companyOther: document.querySelector("#dropdown-container-company-other"),
                person: document.querySelector("#dropdown-container-person"),
                personOther: document.querySelector("#dropdown-container-person-other"),
                confirm: document.querySelector("#dropdown-container-confirm")
            },
            static: {
                lines: [
                    document.querySelector("#dropdown-container-preview-line1"),
                    document.querySelector("#dropdown-container-preview-line2"),
                    document.querySelector("#dropdown-container-preview-line3"),
                    document.querySelector("#dropdown-container-preview-line4"),
                    document.querySelector("#dropdown-container-preview-line5"),
                    document.querySelector("#dropdown-container-preview-line6"),
                    document.querySelector("#dropdown-container-preview-line7"),
                    document.querySelector("#dropdown-container-preview-line8")
                ],
                program: document.querySelector("#selected-program"),
                statueLevel: document.querySelector("#selected-statue-level"),
                entryId: document.querySelector("#selected-entry-id"),
                brand: document.querySelector("#selected-entry-brand"),
                title: document.querySelector("#selected-entry-title"),
                custom: document.querySelector("#selected-is-custom-submission"),
                addToCart: document.querySelector('form[action^="/cart"] [name="add"], button[name="add"]')
            }
        };

        const handle = this.container.dataset.productHandle || "";
        [this.statueLevel, this.program] = getAwardProgram(handle);
        if (this.elements.static.program) this.elements.static.program.value = this.program;
        if (this.elements.static.statueLevel) this.elements.static.statueLevel.value = this.statueLevel;
        
        this.state = {
            year: "",
            mediumId: "",
            entryId: "",
            company: "",
            companyOther: "",
            person: "",
            personOther: "",
            confirm: false,
        };

    }

    async init() {
        if (!this.container) return;
        try {
            const years = await getYears(this.program, this.statueLevel) || [];
            this.setSelectOptions(this.elements.interactive.year, years.map(s=>String(s)), "Select Year");
            this.attachEvents();
            this.resetFrom("year");
            this.render();
        } catch (err) {
            console.error(err);
        }
    }

    attachEvents() {
        const root = this.container;
        root.addEventListener("change", this.onChange);
        root.addEventListener("input", this.onInput);
    }

    onChange = async (e) => {
        const { year, medium, entry, company, person, confirm } = this.elements.interactive;
        const target = e.target;

        if (target === year) {
            this.state.year = year.value;
            this.resetFrom("year");
            this.render();

            if (this.state.year) {
                this.setSelectOptions(medium, [{ value: "", text: "Loading..." }], "Loading...");
                
                const mediums = await getMediums(this.program, this.statueLevel, this.state.year) || [];

                const uniqueMediums = mediums.reduce((acc, curr) => {
                    const extantMedium = acc.find(x => x.mediumName === curr.mediumName)
                    if (extantMedium) {
                        extantMedium.id = `${extantMedium.id},${curr.id}`
                        return acc;
                        }
                    return [...acc, curr];
                }, [])


                const items = uniqueMediums.map(m => ({value: String(m.id), text: m.mediumName}));
                this.setSelectOptions(medium, items, "Select Medium");
                this.setControl(medium, { enabled: true });
            }
            return;
        }

        if (target === medium) {
            this.state.mediumId = medium.value;
            this.resetFrom("medium");
            this.render();

            if (this.state.mediumId) {
                this.setSelectOptions(entry, [{ value: "", text: "Loading..." }], "Loading...");

                let entries = [];

                if (typeof this.state.mediumId === 'string' && this.state.mediumId.includes(",")) {
                    const mediumIds = this.state.mediumId.split(",");

                    try {
                        const promises = mediumIds.map(mediumId => getEntries(mediumId, this.statueLevel));
                        const results = await Promise.allSettled(promises);
                        entries = results.filter(res=>res.status === 'fulfilled')
                            .reduce((acc,curr) => [...acc, ...curr.value], [])
                    } catch (error) {
                        console.error("One of the requests failed:", error);
                    }
                    
                } else {
                    entries = await getEntries(this.state.mediumId, this.statueLevel) || [];
                }

                const items = entries.map(e => ({
                    value: String(e.id),
                    text: e.brandName ? `${e.brandName}: ${e.title}` : e.title,
                    dataBrand: e.brandName || "",
                    dataTitle: e.title || "",
                })).sort((a,b) => a.text.localeCompare(b.text));
                this.setSelectOptions(entry, items, "Select Entry");
                this.setControl(entry, { enabled: true });
            }
            return;
        }

        if (target === entry) {
            this.state.entryId = entry.value;
            this.resetFrom("entry");

            if (this.state.entryId) {
                const entryOption = this.getSelection(entry);

                if (this.elements.static.entryId) {
                    this.elements.static.entryId.value = this.state.entryId || "";
                }

                if (this.elements.static.brand) {
                    const brandFromOption = entryOption?.getAttribute("data-brand");
                    this.elements.static.brand.value = brandFromOption || "";
                }
                if (this.elements.static.title) {
                    const titleFromOption = entryOption?.getAttribute("data-title");
                    this.elements.static.title.value = titleFromOption || "";
                }

                this.setSelectOptions(company, [{ value: "", text: "Loading..." }], "Loading...");
                this.setSelectOptions(person, [{ value: "", text: "Loading..." }], "Loading...");

                const credits = await getCredits(this.state.entryId) || { individuals: [], companies: [] };

                const companies = [...new Set((credits.companies || [])
                    .map(c => c.companyName))]
                    .sort();
                const people = (credits.individuals || [])
                    .map(p => {
                        const title = (p.jobTitle || "").trim();
                        const name = (p.fullName || "").trim();
                        return title && name ? `${title}: ${name}` : name || "";
                    });


                this.setSelectOptions(
                    company,
                    companies.map(c => ({ value: c, text:c }))
                        .concat([{ value: "__OTHER__", text: "Other" }]),
                    "Select Company"
                );

                this.setSelectOptions(
                    person,
                    [{ value: "", text: "None" }]
                        .concat(people.map(p => ({ value: p, text: p })))
                        .concat([{ value: "__OTHER__", text: "Other" }]),
                    "Select Individual"
                );
                
                this.setControl(company, { enabled: true });
                this.setControl(person, { enabled: true });
            }
            this.render();
            return;
        }

        if (target === company) {
            this.state.company = company.value;
            this.render();
            return;
        }

        if (target === person) {
            this.state.person = person.value;
            this.render();
            return;
        }

        if (target === confirm) {
            this.state.confirm = confirm.checked;
            this.render();
            return;
        }
    }

    onInput = (e) => {
        const { companyOther, personOther } = this.elements.interactive;
        const target = e.target;

        if (target === companyOther) {
            this.state.companyOther = target.value;
            this.render();
        }
        if (target === personOther) {
            this.state.personOther = target.value;
            this.render();
        }
    }

    // Update UI
    setControl(el, { enabled, visible, value, required } = {}) {
        if (!el) return;
        if (enabled !== undefined) el.disabled = !enabled;
        if (visible !== undefined) el.style.display = visible ? "" : "none";
        if (required !== undefined) el.required = !!required;
        if (value !== undefined) el.value = value;
    }

    setSelectOptions(select, items, placeholder = "Please Select") {
        if (!select) return;
        const options = [`<option value="">${placeholder}</option>`].concat(
            items.map(o => {
                if (typeof o === "string") {
                    return `<option value="${o}">${o}</option>`;
                } else {
                    const value = o.value ?? o.text ?? "";
                    const text = o.text ?? o.value ?? "";
                    const dataBrand = o.dataBrand ? ` data-brand="${this.sanitize(o.dataBrand)}"` : "";
                    const dataTitle = o.dataTitle ? ` data-title="${this.sanitize(o.dataTitle)}"` : "";
                    const data = `${dataBrand}${dataTitle}`;
                    return `<option value="${value}"${data}>${text}</option>`;
                }
            })
        );
        select.innerHTML = options.join("");
    }

    resetFrom(fromKey) {
        const { medium, entry, company, companyOther, person, personOther } = this.elements.interactive;

        const order = ["year", "medium", "entry", "company", "person"];
        const index = order.indexOf(fromKey);

        // Clear state
        if (index < order.indexOf("medium")) {
            this.state.mediumId = "";
            this.setSelectOptions(medium, [], "Select Medium");
            this.setControl(medium, { enabled: false });
        }
        if (index < order.indexOf("entry")) {
            this.state.entryId = "";
            this.elements.static.brand.value = "";
            this.elements.static.title.value = "";
            this.elements.static.custom.value = "false";
            this.setSelectOptions(entry, [], "Select Entry");
            this.setControl(entry, { enabled: false });
        }
        if (index < order.indexOf("company")) {
            this.state.company = "";
            this.setSelectOptions(company, [], "Select Company");
            this.setControl(company, { enabled: false });
            this.setControl(companyOther, { visible: false, value: "", required: false });
        }
        if (index < order.indexOf("person")) {
            this.state.person = "";
            this.setSelectOptions(person, [{ value: "", text: "None" }], "None");
            this.setControl(person, { enabled: false });
            this.setControl(personOther, { visible: false, value: "", required: false });
        }
    };

    render() {
        const { year, medium, entry, company, companyOther, person, personOther, confirm } = this.elements.interactive;

        this.setControl(medium, { enabled: !!this.state.year });
        this.setControl(entry, { enabled: !!this.state.mediumId });
        this.setControl(company, { enabled: !!this.state.entryId });
        this.setControl(person, { enabled: !!this.state.entryId });

        const showCompanyOther = this.state.company === "__OTHER__";
        this.setControl(companyOther, { visible: showCompanyOther, required: showCompanyOther });

        const showPersonOther = this.state.person === "__OTHER__";
        this.setControl(personOther, { visible: showPersonOther, required: showPersonOther });

        if (this.elements.static.custom) {
            const customCompanyFlag = this.computeIsCustom()
            this.elements.static.custom.value = customCompanyFlag;
        }

        const lines = this.constructPreview();

        this.elements.static.lines.forEach((line, index) => {
            line.value = lines[index] || "";
        });
        this.setAddToCartState();
    }

    constructPreview() {
        // Year / Program – 2025 Clio Awards
        // Medium – Social Media
        // Entry Brand – Cadbury 5 Star
        // Entry Title – Erase Valentine’s Day
        // Credited Company – Wavemaker
        // (Optional) Either
            // Additional Company Credit Line (if it overflows from Line 5)
            // Individual Credit - General Manager: Naina Shewakramani
        // (Optional) Individual Credit (if it overflows from Line 6)
        // (Optional) Catch-all for overflow text
        const { program, brand, title } = this.elements.static;
        const { year, medium, company, person, companyOther, personOther } = this.elements.interactive;

        const isCompanyOther = this.state.company === "__OTHER__";
        const isPersonOther = this.state.person === "__OTHER__";

        const endsWithAwards = program.value.endsWith('Awards');
        const programLine = `${this.getSelectedValue(year)} ${program.value}${endsWithAwards ? '' : ' Awards'}`;
        const mediumLine = this.getSelectedValue(medium);
        const brandLine = brand.value;
        const titleLine = title.value;
        const companyLine = isCompanyOther ? companyOther.value : this.getSelectedValue(company);
        const personLine = isPersonOther ? personOther.value : this.getSelectedValue(person);

        const lines = [
            ...this.truncate(programLine),
            ...this.truncate(mediumLine, false),
            ...this.truncate(brandLine),
            ...this.truncate(titleLine),
            ...this.truncate(companyLine),
            ...this.truncate(personLine),
        ];

        return lines;
    }

    getSelection = (element) => element?.options[element?.selectedIndex || 0]
    getSelectedValue = (element) => {
        return element?.selectedIndex === 0 ? "" : this.getSelection(element)?.text || "";
    }
    
    setAddToCartState() {
        const requiredOk =
            this.state.year &&
            this.state.mediumId &&
            this.state.entryId &&
            (this.state.company === "__OTHER__" ? (this.state.companyOther || "").trim() : this.state.company) &&
            this.state.confirm;

        const allow = !!requiredOk;
        const button = this.elements.static.addToCart;
        if (button) {
            button.disabled = !allow;
            button.textContent = allow ? "Add to cart" : "Complete details to continue";
        }
    }

    truncate(value,split=true) {
        if (!value || value == 'None') return "";
        if (value.length <= CustomDropDowns.MAXCHARACTERS) return [value.trim()];
        if (split && value.includes(":")) return value.split(":").map(this.truncate);
        return [value.trim().slice(0, CustomDropDowns.MAXCHARACTERS - 1)];
    }

    sanitize(value) {
        return value.replaceAll('"', '&quot;');
    }

    computeIsCustom() {
        return (
            (this.state.company === "__OTHER__") ||
            (this.state.person === "__OTHER__")
        );
    }
}
